import {legacyLineContent, plainRichDetails} from "../../shared/document-line-content";
import {invoiceOutstandingMinor} from "../../shared/invoice-settlement";
import type {InvoiceDraftRecord} from "../pages/invoiceApi";
import type {RegisterKind} from "./registerModel";

/** A work summary comes only from document lines, never customer notes. */
export function documentWorkSummary(lines: InvoiceDraftRecord["lines"]) {
  const titles = lines.map(line => {
    const content = line.title?.trim() || legacyLineContent(line.description).title || plainRichDetails(line.details ?? []).trim().split("\n").find(Boolean) || "";
    return content.replace(/\s+/g, " ").trim();
  }).filter(Boolean);
  return {text:titles[0] ?? "No description yet", moreCount:Math.max(0,titles.length-1), sortText:titles[0] ?? "", missing:titles.length===0, fullText:titles.join(" · ")};
}

/** The existing mobile amount semantics, shared with Home without new accounting. */
export function documentDisplayAmount(record: InvoiceDraftRecord, kind: RegisterKind) {
  const outstanding = invoiceOutstandingMinor(record);
  const hasBalance = kind === "invoice" && record.documentState === "issued" && outstanding > 0;
  return {minor:hasBalance ? outstanding : record.grandTotalMinor,
    label:hasBalance ? "Due" : record.documentState === "draft" ? "Draft total" : kind === "estimate" ? "Estimate total" : "Total",
    originalTotal:hasBalance && outstanding !== record.grandTotalMinor ? record.grandTotalMinor : null};
}
